import React from 'react';

const usePaste = <T extends HTMLDivElement>(
  fn: (type: string, value: string) => void,
  deps: any[]
): React.RefObject<T> => {
  const ref = React.useRef<T>(null);
  React.useEffect(() => {
    let listenerFn = (event: ClipboardEvent) => {
      try {
        if (event.clipboardData) {
          console.log(event.clipboardData.getData('text'));
          if (event.clipboardData.files && event.clipboardData.files.length) {
            console.log('Files');
            for (let i = 0; i < event.clipboardData.files.length; i += 1) {
              const file = event.clipboardData.files[i];
              const URLObj = window.URL || window.webkitURL;
              const reader = new FileReader();
              reader.onload = function () {
                fn('image', String(reader.result));
              };
              reader.onerror = function () {
                console.log('PASTE', 'Incorrect file.');
              };
              reader.readAsDataURL(file);
            }
          } else {
            fn('text', event.clipboardData.getData('text'));
          }
          event.preventDefault();
        }
      } catch (e) {
        console.log('Clipboard events not supported ', e);
      }
    };
    document.addEventListener('paste', listenerFn);
    return () => {
      document.removeEventListener('paste', listenerFn);
    };
  }, [ref, fn, ...deps]);
  return ref;
};

export default usePaste;
